export interface LegalSection {
  title: string;
  paragraphs?: string[];
  bullets?: string[];
}

export const PUBLIC_OFFER_TITLE = 'Публичная оферта';
export const PUBLIC_OFFER_SUBTITLE = 'о заключении договора об оказании услуг';

export const PUBLIC_OFFER_SECTIONS: LegalSection[] = [
  {
    title: 'Общие положения',
    paragraphs: [
      'В настоящей Публичной оферте содержатся условия заключения договора об оказании услуг.',
      'Совершение действий, указанных в оферте, подтверждает согласие Сторон заключить договор на условиях, изложенных ниже.',
      'Текст оферты является официальным публичным предложением Исполнителя заключить договор в соответствии с пунктом 2 статьи 437 Гражданского кодекса Российской Федерации.',
      'Договор считается заключённым с момента совершения действий, означающих полное и безоговорочное принятие условий оферты.',
    ],
  },
  {
    title: 'Термины и определения',
    bullets: [
      'Договор — текст настоящей оферты с приложениями, акцептованный Заказчиком путём совершения конклюдентных действий.',
      'Конклюдентные действия — поведение, выражающее согласие заключить, изменить или расторгнуть договор.',
      'Сайт Исполнителя — https://app.inhound.club/.',
      'Стороны договора — Исполнитель и Заказчик.',
      'Услуга — услуга, оказываемая Исполнителем Заказчику в порядке и на условиях настоящей оферты.',
    ],
  },
  {
    title: 'Предмет договора',
    bullets: [
      'Исполнитель обязуется оказать Заказчику услуги, а Заказчик обязуется оплатить их в размере, порядке и сроки, установленные договором.',
      'Наименование, количество, порядок и иные условия оказания услуг определяются на основании сведений Исполнителя при оформлении заявки Заказчиком либо устанавливаются на сайте Исполнителя.',
      'Исполнитель вправе оказывать услуги лично либо с привлечением третьих лиц.',
      'Договор заключается путём акцепта оферты через действия, связанные с регистрацией учётной записи, оформлением заявки, оплатой услуг и фактическим оказанием услуг.',
    ],
  },
  {
    title: 'Права и обязанности Исполнителя',
    bullets: [
      'Оказать услуги в соответствии с положениями договора, в сроки и объёме, указанные в договоре или на сайте.',
      'Предоставлять Заказчику доступ к разделам сайта, необходимым для получения информации и услуг.',
      'Хранить и обрабатывать персональные данные Заказчика конфиденциально и использовать их только для оказания услуг.',
      'Вправе изменять сроки оказания услуг и условия оферты, публикуя изменения на сайте. Новые условия действуют только в отношении вновь заключаемых договоров.',
    ],
  },
  {
    title: 'Права и обязанности Заказчика',
    bullets: [
      'Предоставлять достоверную информацию о себе при получении услуг.',
      'Не воспроизводить, не копировать, не продавать и не передавать третьим лицам материалы и информацию, полученные в рамках оказания услуг, за исключением личного использования.',
      'Принять оказанные услуги Исполнителя.',
      'Вправе требовать возврат денежных средств в случаях, предусмотренных действующим законодательством Российской Федерации.',
      'Подтверждает, что условия договора понятны и принимаются полностью без оговорок.',
    ],
  },
  {
    title: 'Цена и порядок расчётов',
    bullets: [
      'Стоимость услуг и порядок оплаты определяются на основании сведений Исполнителя при оформлении заявки либо на сайте Исполнителя.',
      'Все расчёты по договору производятся в безналичном порядке.',
    ],
  },
  {
    title: 'Конфиденциальность и безопасность',
    bullets: [
      'Стороны обеспечивают конфиденциальность и безопасность персональных данных в соответствии с актуальной редакцией Федерального закона № 152-ФЗ «О персональных данных» и Федерального закона № 149-ФЗ «Об информации, информационных технологиях и о защите информации».',
      'Стороны обязуются сохранять конфиденциальность информации, полученной в ходе исполнения договора, и принять меры для её защиты от разглашения.',
      'Конфиденциальной считается любая информация, передаваемая в процессе исполнения договора и подлежащая защите.',
    ],
  },
  {
    title: 'Форс-мажор',
    bullets: [
      'Стороны освобождаются от ответственности за неисполнение обязательств вследствие чрезвычайных и непредотвратимых обстоятельств.',
      'Сторона обязана уведомить другую сторону о наступлении таких обстоятельств в течение 30 рабочих дней.',
      'Если обстоятельства непреодолимой силы продолжаются более 60 рабочих дней, каждая сторона вправе отказаться от договора в одностороннем порядке.',
    ],
  },
  {
    title: 'Ответственность сторон',
    bullets: [
      'Стороны несут ответственность в соответствии с условиями настоящей оферты и действующим законодательством Российской Федерации.',
      'Исполнитель не несёт ответственности за неисполнение обязательств, произошедшее по вине Заказчика.',
      'Сторона, нарушившая обязательства, обязана возместить другой стороне причинённые убытки.',
    ],
  },
  {
    title: 'Срок действия оферты',
    bullets: [
      'Оферта вступает в силу с момента размещения на сайте Исполнителя и действует до момента её отзыва.',
      'Исполнитель вправе изменить условия оферты или отозвать её в любой момент, публикуя актуальную редакцию на сайте либо уведомляя Заказчика иным способом.',
      'Договор действует с момента акцепта до полного исполнения сторонами обязательств.',
    ],
  },
  {
    title: 'Дополнительные условия',
    bullets: [
      'Договор регулируется действующим законодательством Российской Федерации.',
      'Споры подлежат обязательному досудебному урегулированию и, при недостижении соглашения, разрешаются в порядке, установленном законодательством Российской Федерации.',
      'Язык договора и всего взаимодействия сторон — русский.',
      'Ссылки на сторонние сайты и материалы размещаются исключительно в информационных целях; Исполнитель не несёт ответственности за их содержание.',
    ],
  },
];

export const PUBLIC_OFFER_REQUISITES = [
  'Полное наименование: ИП Анников Павел Андреевич',
  'ИНН: 561202861214',
  'ОГРНИП: 319565800069512',
  'Контактный e-mail: info@inhound.club',
];
